import React, { useState } from 'react';
import { Container, ThisCard } from './styles';

function CustomBodyContent({ data, setSelectedComunicado, disableDefaultScroll }) {
  const [linhaAtiva, setLinhaAtiva] = useState([]);

  const extractTextFromHTML = htmlString => {
    if (!htmlString) return '';
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = htmlString;
    return tempDiv.textContent || tempDiv.innerText || '';
  };

  return (
    <Container disableDefaultScroll={disableDefaultScroll}>
      {data?.map((thisData, i) => {
        const dataCadastroFormatada = thisData?.dataCadastro
          ? new Date(thisData.dataCadastro).toLocaleDateString('pt-BR')
          : '';

        const textoTipoComunicado = thisData?.destaque ? 'Destaque' : 'Comum';

        // Links pode vir como string JSON ou array
        const linksArray =
          typeof thisData?.links === 'string'
            ? (() => {
                try {
                  return JSON.parse(thisData?.links || '[]');
                } catch (e) {
                  return [];
                }
              })()
            : thisData?.links || [];

        const hasLinks = Array.isArray(linksArray) && linksArray.length > 0;
        const hasAnexos = Array.isArray(thisData?.anexos) && thisData.anexos.length > 0;

        // Texto da label de link: host do primeiro link ou fallback
        let linkLabelText = 'Sem links';
        if (hasLinks) {
          const first = linksArray[0];
          const raw =
            typeof first === 'string' ? first : first?.url || first?.link || first?.titulo || '';
          try {
            const u = new URL(raw);
            linkLabelText = u.host;
          } catch (e) {
            linkLabelText = raw || '1 link';
          }
        }

        return (
          <ThisCard
            className={linhaAtiva === thisData?.id ? 'card-item ativo' : 'card-item'}
            {...{ data: thisData, linhaAtiva, setLinhaAtiva }}
            key={thisData?.id || i}
            id={thisData?.id || i}
            index={i}
            ativo={linhaAtiva === thisData?.id ? true : false}
            destaque={thisData?.destaque}
            onClick={() => {
              setLinhaAtiva(thisData?.id);
              setSelectedComunicado && setSelectedComunicado(thisData);
            }}
          >
            <div className="card-body">
              <div className="card-text">
                <p className="titulo">{thisData?.titulo}</p>
                {thisData?.conteudo && (
                  <p className="descricao">{extractTextFromHTML(thisData.conteudo)}</p>
                )}
              </div>

              <div className="labels">
                <div className={`label link ${hasLinks ? 'filled' : 'empty'}`}>
                  <i className="material-icons">link</i>
                  <span>{linkLabelText}</span>
                </div>
                <div className={`label anexos ${hasAnexos ? 'filled' : 'empty'}`}>
                  <i className="material-icons">insert_drive_file</i>
                  <span>
                    {hasAnexos
                      ? `${thisData.anexos.length} ${
                          thisData.anexos.length === 1 ? 'anexo' : 'anexos'
                        }`
                      : 'Sem anexos'}
                  </span>
                </div>
              </div>

              <div className="card-footer">
                <span
                  className={
                    thisData?.destaque ? 'tipo-comunicado destaque' : 'tipo-comunicado comum'
                  }
                >
                  {textoTipoComunicado}
                </span>
                <span className="data-comunicado">
                  <i className="material-icons">calendar_today</i>
                  {dataCadastroFormatada}
                </span>
              </div>
            </div>
          </ThisCard>
        );
      })}
    </Container>
  );
}

export default CustomBodyContent;
